import React from "react";
import { connect } from "react-redux";
import { Col } from 'react-bootstrap';
import EgCard from "./EgCard";

const EGCards = (props) => {
    const { workDetails, isRequestingWorkedAcres, isRequestingWorkedEG } = props;

    const workedEg = workDetails && workDetails.egList ? workDetails.egList : [];
    const isRequesting = isRequestingWorkedEG || isRequestingWorkedAcres;

    return <Col className={`eg-list ${(isRequesting || workedEg.length === 0) && "m-auto"}`} lg={6} md={6} sm={6}>
        {(isRequesting || workedEg.length === 0)
            ? <div className="no-records-found">{isRequesting ? "Loading..." : "No equipment groups found"}</div>
            : workedEg.map(item => <EgCard key={item.egId} item={item} />)}
    </Col>
}


const mapStateToProps = (state, ownProps) => ({
    workDetails: state.farmMonitor.workedById.payload[`${ownProps.shapeRefId}_${ownProps.workTypeId}`],
    isRequestingWorkedAcres: state.farmMonitor.workedById.isRequesting,
    isRequestingWorkedEG: state.farmMonitor.workedById.isRequestingWorkedEG
});

export default connect(mapStateToProps)(EGCards);